import { useEffect, useState } from "react";
import api from "@/lib/api";
import StatusBadge from "@/components/common/StatusBadge";
import { Loader2, Server, Database, Cloud, Box, Activity } from "lucide-react";

export default function Monitoring() {
  const [data, setData] = useState(null);

  const load = () => api.get("/api/admin/monitoring/status").then(({ data }) => setData(data));
  useEffect(() => { load(); const t = setInterval(load, 8000); return () => clearInterval(t); }, []);

  if (!data) return <div className="text-[var(--text-2)] flex items-center gap-2"><Loader2 className="animate-spin" size={14}/> Loading status…</div>;

  return (
    <div className="space-y-8" data-testid="monitoring-page">
      <div className="text-[var(--text-2)] text-sm">Live platform health. Services marked <span className="badge badge-warning">MOCKED</span> are simulated for MVP.</div>

      <div>
        <div className="text-xs uppercase tracking-widest text-[var(--text-3)] mb-3">Core infrastructure</div>
        <div className="grid grid-cols-2 md:grid-cols-3 gap-3">
          {Object.entries(data.services).map(([name, s]) => (
            <div key={name} className="card-surface p-4 fade-up" data-testid={`service-${name}`}>
              <div className="flex items-center justify-between mb-2">
                <div className="flex items-center gap-2">
                  {name === "mongodb" || name === "postgresql" ? <Database size={15}/> :
                   name === "redis" ? <Box size={15}/> :
                   name === "s3" || name === "cloudfront" ? <Cloud size={15}/> :
                   <Server size={15}/>}
                  <div className="font-medium text-sm capitalize">{name}</div>
                </div>
                {s.mocked && <span className="badge badge-warning">MOCKED</span>}
              </div>
              <div className="flex items-center gap-2">
                <StatusBadge status={typeof s.healthy === "boolean" ? (s.healthy ? "healthy" : "down") : (s.status || "healthy")}/>
              </div>
              {s.note && <div className="text-[10px] text-[var(--text-3)] mt-2">{s.note}</div>}
            </div>
          ))}
        </div>
      </div>

      <div>
        <div className="text-xs uppercase tracking-widest text-[var(--text-3)] mb-3">Game providers</div>
        <div className="card-surface overflow-hidden">
          <table className="aggr-table">
            <thead><tr><th>Provider</th><th>Status</th><th>Latency</th><th>Uptime</th><th>Last checked</th></tr></thead>
            <tbody>
              {data.providers.map(p => (
                <tr key={p.provider_code}>
                  <td className="font-medium">{p.name}</td>
                  <td><StatusBadge status={p.status}/></td>
                  <td className="font-mono text-xs">{p.latency_ms}ms</td>
                  <td className="font-mono text-xs">{p.uptime_pct}%</td>
                  <td className="font-mono text-xs text-[var(--text-3)]">{new Date(p.last_checked).toLocaleTimeString()}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-3">
        <div className="card-surface p-4">
          <div className="text-[10px] uppercase tracking-widest text-[var(--text-3)]">Transaction backlog</div>
          <div className="text-2xl font-semibold font-mono mt-2 text-[var(--gold)]">{data.queue.transaction_stream_backlog}</div>
        </div>
        <div className="card-surface p-4">
          <div className="text-[10px] uppercase tracking-widest text-[var(--text-3)]">Webhook backlog</div>
          <div className="text-2xl font-semibold font-mono mt-2 text-[var(--gold)]">{data.queue.webhook_stream_backlog}</div>
        </div>
        <div className="card-surface p-4">
          <div className="text-[10px] uppercase tracking-widest text-[var(--text-3)]">Failed callbacks</div>
          <div className="text-2xl font-semibold font-mono mt-2 text-[var(--error)]">{data.failed_callbacks}</div>
        </div>
      </div>
    </div>
  );
}
